import { pick } from 'ramda';
import { useEffect } from 'react';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useDetectCurrency = () => {
    const { defaultCurrency, locationJson } = useAppSelector(pick(['defaultCurrency', 'locationJson']));
    const { countrySetByGeoIp, currencyCode, isLoggedIn } = useUserSelector(pick(['countrySetByGeoIp', 'currencyCode', 'isLoggedIn']));
    const dispatch = useDynamicReducerDispatch();
    const locationItems = locationJson?.items;

    useEffect(() => {
        if (isLoggedIn && currencyCode) {
            dispatch(actions.setLimitsCurrency(currencyCode || defaultCurrency));

            return;
        }

        if (!defaultCurrency || !countrySetByGeoIp || !locationItems) {
            return;
        }

        const countryMappingObj = locationItems?.find(item => item.countryCode === countrySetByGeoIp) || {};
        const currency = countryMappingObj?.currency || defaultCurrency;

        dispatch(actions.setLimitsCurrency(currency));
    }, [defaultCurrency, locationItems, countrySetByGeoIp, dispatch, isLoggedIn, currencyCode]);
};
